import Facet from './Facet';
import RangeFacet from './range';
import TermFacet from './TermFacet';
import type { FacetConfiguration } from '../../types';

type Props = {
  configuration?: Record<string, FacetConfiguration>;
};

const MAPPING = {
  range: RangeFacet,
  term: TermFacet,
};

const DynamicFacets: React.FC<Props> = ({ configuration }) => {
  if (!configuration) return null;

  return (
    <>
      {Object.keys(configuration).map((attribute) => {
        const facet = configuration[attribute];

        if (facet.type === 'term' && (!facet.terms || facet.terms.length < 2)) return null;

        const Component = MAPPING[facet.type];
        const FinalComponent = <Component key={attribute} label={facet.label} attribute={attribute} />;

        return (
          <Facet key={attribute} attribute={attribute}>
            {FinalComponent}
          </Facet>
        );
      })}
    </>
  );
};

export default DynamicFacets;
